/**
 * <quantity-input> — wraps the -/input/+ markup from quantity-selector.liquid.
 * Dispatches a bubbling 'quantity-update' CustomEvent so any ancestor
 * (cart line, PDP buy box) can react without this component knowing about
 * cart.js at all.
 */
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.querySelectorAll('button').forEach((btn) =>
      btn.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    if (event.currentTarget.name === 'plus') this.input.stepUp();
    else this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);
